import { useMutation, useQueryClient } from '@tanstack/react-query';
import AuthService from '@clickersphere/core/services/AuthService';

export function useSignOut() {
  const queryClient = useQueryClient();
  const { mutateAsync: signOutAsync } = useMutation({
    mutationFn: () => AuthService.signOut(),
    onMutate() {
      queryClient.clear();
    },
  });

  return {
    signOutAsync,
  };
}
